export default "__VITE_ASSET__CBWasWlK__"